module.exports = __webpack_public_path__ + "img/Ilustraciones-Difarmer-5.10cfd9c7.jpg";